module.exports = __webpack_public_path__ + "static/img/fate_icon.9a34f673.jpg";